module.exports = __webpack_public_path__ + "img/2x.ee8cac5.jpg";